import LeafletUtil from 'views/utils/LeafletMap/utils/Util';

var DirectionService = function(args) {
    this.transitMode = null;
    this.updateTransitionMode(args.transitMode || null);
    return this;
};

//MUST OVERRIDE
DirectionService.prototype.fetch = function fetch() {};

//UPDATE METHODS
DirectionService.prototype.updateTransitionMode = function updateTransitionMode(transitionMode) {
    if (transitionMode && transitionMode.parent) {
        this.transitMode =
            transitionMode.parent === 'cycling'
                ? LeafletUtil.TRANSIT_MODE.CYCLING
                : LeafletUtil.TRANSIT_MODE.PEDESTRIAN;
    } else {
        this.transitMode = LeafletUtil.TRANSIT_MODE.PEDESTRIAN;
    }
};

export default DirectionService;
